import { combineReducers } from "redux";
import trialuser from "./TrialAcctUser/reducer";
import layout from "./layout/reducer";
import login from "./login/reducer";
import forgetPassword from "./forgetPwd/reducer";
import cognitoUser from "./CognitoUser/reducer";
const rootReducer = combineReducers({
    trialuser,
    layout,
    //Added the following
    login,
    forgetPassword,
    cognitoUser,
});

export default rootReducer;